export const LOCAL_AUTHORITY_KEY = "LOCAL_AUTHORITY_KEY";

// region PageStatuses
export const NEW_PAGE_STATUS = "NEW_PAGE_STATUS";
export const UPDATING_PAGE_STATUS = "UPDATING_PAGE_STATUS";
export const VIEW_PAGE_STATUS = "VIEW_PAGE_STATUS";
// endregion